export function interactiveStateStyles(theme) {
    return {
        "&:hover": { backgroundColor: theme.palette.state.hover },
        "&.Mui-focusVisible, &:focus-visible": {
            backgroundColor: theme.palette.state.focus,
            outline: `1.2px solid ${theme.palette.state.outline}`,
            outlineOffset: "-1.2px",
        },
    }
}
